import { SkuRankingsList } from "./SkuRankingsList";

export default {
  list: SkuRankingsList,
};
